module.exports = __webpack_public_path__ + "img/shgybz.42aba316.png";